// This file is auto-generated. Do not edit manually.
import { CodeBlock as islands_CodeBlock } from "@/components/islands/CodeBlock.tsx";
import { TickRate as islands_TickRate } from "@/components/islands/TickRate.tsx";
import { LatencyMap as islands_LatencyMap } from "@/components/islands/LatencyMap.tsx";
import { Interpolation as islands_Interpolation } from "@/components/islands/Interpolation.tsx";
import { ServerTime as islands_ServerTime } from "@/components/islands/ServerTime.tsx";
import { UserAvatar as common_UserAvatar } from "@/components/common/UserAvatar.tsx";
import { HomePage as pages_HomePage } from "@/components/pages/HomePage.tsx";
import { Header as layout_Header } from "@/components/layout/Header.tsx";
import { FlashMessages as layout_FlashMessages } from "@/components/layout/FlashMessages.tsx";
import { ToggleField as input_ToggleField } from "@/components/input/ToggleField.tsx";
import { NumberField as input_NumberField } from "@/components/input/NumberField.tsx";
import { SelectField as input_SelectField } from "@/components/input/SelectField.tsx";
import { MusicXMLPreview as input_MusicXMLPreview } from "@/components/input/MusicXMLPreview.tsx";
import { TextField as input_TextField } from "@/components/input/TextField.tsx";
import { GameLobby as features_rooms_GameLobby } from "@/features/rooms/components/GameLobby.tsx";
import { Menu as features_playground_Menu } from "@/features/playground/components/Menu.tsx";
import { HUD as features_playground_HUD } from "@/features/playground/components/HUD.tsx";
import { PlaygroundRoom as features_playground_PlaygroundRoom } from "@/features/playground/components/PlaygroundRoom.tsx";
import { Menu as features_dino_Menu } from "@/features/dino/components/Menu.tsx";
import { Inventory as features_dino_Inventory } from "@/features/dino/components/Inventory.tsx";
import { VoxholeRoom as features_dino_VoxholeRoom } from "@/features/dino/components/VoxholeRoom.tsx";
import { PlayerList as features_dino_PlayerList } from "@/features/dino/components/PlayerList.tsx";
import { HUD as features_dino_HUD } from "@/features/dino/components/HUD.tsx";
import { QuizAdmin as features_quiz_QuizAdmin } from "@/features/quiz/components/QuizAdmin.tsx";
import { QuizViewLocked as features_quiz_views_QuizViewLocked } from "@/features/quiz/components/views/QuizViewLocked.tsx";
import { QuizViewBanned as features_quiz_views_QuizViewBanned } from "@/features/quiz/components/views/QuizViewBanned.tsx";
import { QuizViewNotFound as features_quiz_views_QuizViewNotFound } from "@/features/quiz/components/views/QuizViewNotFound.tsx";
import { QuizSidebar as features_quiz_QuizSidebar } from "@/features/quiz/components/QuizSidebar.tsx";
import { QuizLobby as features_quiz_QuizLobby } from "@/features/quiz/components/QuizLobby.tsx";
import { QuizQuitModal as features_quiz_QuizQuitModal } from "@/features/quiz/components/QuizQuitModal.tsx";
import { QuizPlayerMenu as features_quiz_QuizPlayerMenu } from "@/features/quiz/components/QuizPlayerMenu.tsx";
import { QuestionEditor as features_quiz_QuestionEditor } from "@/features/quiz/components/QuestionEditor.tsx";
import { QuizRoom as features_quiz_QuizRoom } from "@/features/quiz/components/QuizRoom.tsx";
import { EulaRegistration as features_legal_EulaRegistration } from "@/features/legal/components/EulaRegistration.tsx";
import { EulaPageContent as features_legal_EulaPageContent } from "@/features/legal/components/EulaPageContent.tsx";
import { GeoQuitModal as features_geo_GeoQuitModal } from "@/features/geo/components/GeoQuitModal.tsx";
import { GeoSidebar as features_geo_GeoSidebar } from "@/features/geo/components/GeoSidebar.tsx";
import { GeoLobby as features_geo_GeoLobby } from "@/features/geo/components/GeoLobby.tsx";
import { GeoViewNotFound as features_geo_views_GeoViewNotFound } from "@/features/geo/components/views/GeoViewNotFound.tsx";
import { GeoViewLocked as features_geo_views_GeoViewLocked } from "@/features/geo/components/views/GeoViewLocked.tsx";
import { GeoViewBanned as features_geo_views_GeoViewBanned } from "@/features/geo/components/views/GeoViewBanned.tsx";
import { GeoPuzzleMap as features_geo_GeoPuzzleMap } from "@/features/geo/components/GeoPuzzleMap.tsx";
import { GeoRoom as features_geo_GeoRoom } from "@/features/geo/components/GeoRoom.tsx";
import { GeoPlayerMenu as features_geo_GeoPlayerMenu } from "@/features/geo/components/GeoPlayerMenu.tsx";
import { BabylonGame as features_voxel_BabylonGame } from "@/features/voxel/components/BabylonGame.tsx";
import { VoxelViewNotFound as features_voxel_views_VoxelViewNotFound } from "@/features/voxel/components/views/VoxelViewNotFound.tsx";
import { VoxelLobby as features_voxel_VoxelLobby } from "@/features/voxel/components/VoxelLobby.tsx";
import { VoxelMenu as features_voxel_VoxelMenu } from "@/features/voxel/components/VoxelMenu.tsx";
import { LoadingScreen as features_attack_LoadingScreen } from "@/features/attack/components/LoadingScreen.tsx";
import { CharacterSelect as features_attack_CharacterSelect } from "@/features/attack/components/CharacterSelect.tsx";
import { AttackMenu as features_attack_AttackMenu } from "@/features/attack/components/AttackMenu.tsx";
import { Menu as features_voxhole_Menu } from "@/features/voxhole/components/Menu.tsx";
import { Inventory as features_voxhole_Inventory } from "@/features/voxhole/components/Inventory.tsx";
import { VoxholeRoom as features_voxhole_VoxholeRoom } from "@/features/voxhole/components/VoxholeRoom.tsx";
import { PlayerList as features_voxhole_PlayerList } from "@/features/voxhole/components/PlayerList.tsx";
import { HUD as features_voxhole_HUD } from "@/features/voxhole/components/HUD.tsx";
import { SpaceHUD as features_space_SpaceHUD } from "@/features/space/components/SpaceHUD.tsx";
import { BanManager as features_auth_BanManager } from "@/features/auth/components/BanManager.tsx";
import { ProfileAvatarUploader as features_auth_ProfileAvatarUploader } from "@/features/auth/components/ProfileAvatarUploader.tsx";
import { DeleteAccount as features_auth_DeleteAccount } from "@/features/auth/components/DeleteAccount.tsx";
import { ProfileNameEditor as features_auth_ProfileNameEditor } from "@/features/auth/components/ProfileNameEditor.tsx";
import { ReservedRoomManager as features_auth_ReservedRoomManager } from "@/features/auth/components/ReservedRoomManager.tsx";
import { ApiTokenManager as features_auth_ApiTokenManager } from "@/features/auth/components/ApiTokenManager.tsx";
import { LeafletMapIsland as features_elections_LeafletMapIsland } from "@/features/elections/components/LeafletMapIsland.tsx";
import { ElectionMap as features_elections_ElectionMap } from "@/features/elections/components/ElectionMap.tsx";
import { BBRoom as features_bb_BBRoom } from "@/features/bb/components/BBRoom.tsx";
import { ChessBoard as features_chess_ChessBoard } from "@/features/chess/components/ChessBoard.tsx";
import { ChessLobby as features_chess_ChessLobby } from "@/features/chess/components/ChessLobby.tsx";
import { ChessRoom as features_chess_ChessRoom } from "@/features/chess/components/ChessRoom.tsx";
import { ChessViewNotFound as features_chess_views_ChessViewNotFound } from "@/features/chess/components/views/ChessViewNotFound.tsx";

export const components = {
  "islands/CodeBlock": islands_CodeBlock,
  "islands/TickRate": islands_TickRate,
  "islands/LatencyMap": islands_LatencyMap,
  "islands/Interpolation": islands_Interpolation,
  "islands/ServerTime": islands_ServerTime,
  "common/UserAvatar": common_UserAvatar,
  "pages/HomePage": pages_HomePage,
  "layout/Header": layout_Header,
  "layout/FlashMessages": layout_FlashMessages,
  "input/ToggleField": input_ToggleField,
  "input/NumberField": input_NumberField,
  "input/SelectField": input_SelectField,
  "input/MusicXMLPreview": input_MusicXMLPreview,
  "input/TextField": input_TextField,
  "features/rooms/GameLobby": features_rooms_GameLobby,
  "features/playground/Menu": features_playground_Menu,
  "features/playground/HUD": features_playground_HUD,
  "features/playground/PlaygroundRoom": features_playground_PlaygroundRoom,
  "features/dino/Menu": features_dino_Menu,
  "features/dino/Inventory": features_dino_Inventory,
  "features/dino/VoxholeRoom": features_dino_VoxholeRoom,
  "features/dino/PlayerList": features_dino_PlayerList,
  "features/dino/HUD": features_dino_HUD,
  "features/quiz/QuizAdmin": features_quiz_QuizAdmin,
  "features/quiz/views/QuizViewLocked": features_quiz_views_QuizViewLocked,
  "features/quiz/views/QuizViewBanned": features_quiz_views_QuizViewBanned,
  "features/quiz/views/QuizViewNotFound": features_quiz_views_QuizViewNotFound,
  "features/quiz/QuizSidebar": features_quiz_QuizSidebar,
  "features/quiz/QuizLobby": features_quiz_QuizLobby,
  "features/quiz/QuizQuitModal": features_quiz_QuizQuitModal,
  "features/quiz/QuizPlayerMenu": features_quiz_QuizPlayerMenu,
  "features/quiz/QuestionEditor": features_quiz_QuestionEditor,
  "features/quiz/QuizRoom": features_quiz_QuizRoom,
  "features/legal/EulaRegistration": features_legal_EulaRegistration,
  "features/legal/EulaPageContent": features_legal_EulaPageContent,
  "features/geo/GeoQuitModal": features_geo_GeoQuitModal,
  "features/geo/GeoSidebar": features_geo_GeoSidebar,
  "features/geo/GeoLobby": features_geo_GeoLobby,
  "features/geo/views/GeoViewNotFound": features_geo_views_GeoViewNotFound,
  "features/geo/views/GeoViewLocked": features_geo_views_GeoViewLocked,
  "features/geo/views/GeoViewBanned": features_geo_views_GeoViewBanned,
  "features/geo/GeoPuzzleMap": features_geo_GeoPuzzleMap,
  "features/geo/GeoRoom": features_geo_GeoRoom,
  "features/geo/GeoPlayerMenu": features_geo_GeoPlayerMenu,
  "features/voxel/BabylonGame": features_voxel_BabylonGame,
  "features/voxel/views/VoxelViewNotFound": features_voxel_views_VoxelViewNotFound,
  "features/voxel/VoxelLobby": features_voxel_VoxelLobby,
  "features/voxel/VoxelMenu": features_voxel_VoxelMenu,
  "features/attack/LoadingScreen": features_attack_LoadingScreen,
  "features/attack/CharacterSelect": features_attack_CharacterSelect,
  "features/attack/AttackMenu": features_attack_AttackMenu,
  "features/voxhole/Menu": features_voxhole_Menu,
  "features/voxhole/Inventory": features_voxhole_Inventory,
  "features/voxhole/VoxholeRoom": features_voxhole_VoxholeRoom,
  "features/voxhole/PlayerList": features_voxhole_PlayerList,
  "features/voxhole/HUD": features_voxhole_HUD,
  "features/space/SpaceHUD": features_space_SpaceHUD,
  "features/auth/BanManager": features_auth_BanManager,
  "features/auth/ProfileAvatarUploader": features_auth_ProfileAvatarUploader,
  "features/auth/DeleteAccount": features_auth_DeleteAccount,
  "features/auth/ProfileNameEditor": features_auth_ProfileNameEditor,
  "features/auth/ReservedRoomManager": features_auth_ReservedRoomManager,
  "features/auth/ApiTokenManager": features_auth_ApiTokenManager,
  "features/elections/LeafletMapIsland": features_elections_LeafletMapIsland,
  "features/elections/ElectionMap": features_elections_ElectionMap,
  "features/bb/BBRoom": features_bb_BBRoom,
  "features/chess/ChessBoard": features_chess_ChessBoard,
  "features/chess/ChessLobby": features_chess_ChessLobby,
  "features/chess/ChessRoom": features_chess_ChessRoom,
  "features/chess/views/ChessViewNotFound": features_chess_views_ChessViewNotFound,
};

export type ComponentName = keyof typeof components;
